import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import LayoutMain from '../views/layout/LayoutMain'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'index' }
    }]
  }
]
export const asyncRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/userList',
    name: 'user',
    meta: { title: '用户', icon: 'user' },
    hidden: true,
    children: [
      {
        path: 'editUserPass',
        name: 'editUserPass',
        component: () => import('@/views/user/editUserPass'),
        meta: { title: '修改用户密码' },
        hidden: true
      }]
  },



  // {
  //   path:'/ums',
  //   component: Layout,
  //   redirect: '/ums/admin',
  //   name: 'ums',
  //   meta: {title: '系统设置', icon: 'ums'},
  //   children: [
  //     {
  //       path: 'admin',
  //       name: 'admin',
  //       component: () => import('@/views/ums/admin/index'),
  //       meta: {title: '用户列表', icon: 'ums-admin'}
  //     },
  //     {
  //       path: 'addAdmin',
  //       name: 'addAdmin',
  //       component: () => import('@/views/member/admin/add'),
  //       meta: {title: '添加商家会员'},
  //       hidden: true
  //     },{
  //       path:'updateAdmin',
  //       name:'updateAdmin',
  //       component: () => import('@/views/member/admin/update'),
  //       meta:{title:'修改商铺'},
  //       hidden:true
  //     },
  //     {
  //       path: 'role',
  //       name: 'role',
  //       component: () => import('@/views/ums/role/index'),
  //       meta: {title: '角色列表', icon: 'ums-role'}
  //     },
  //     {
  //       path: 'allocMenu',
  //       name: 'allocMenu',
  //       component: () => import('@/views/ums/role/allocMenu'),
  //       meta: {title: '分配菜单'},
  //       hidden: true
  //     },
  //     {
  //       path: 'allocResource',
  //       name: 'allocResource',
  //       component: () => import('@/views/ums/role/allocResource'),
  //       meta: {title: '分配资源'},
  //       hidden: true
  //     },
  //     {
  //       path: 'menu',
  //       name: 'menu',
  //       component: () => import('@/views/ums/menu/index'),
  //       meta: {title: '菜单列表', icon: 'ums-menu'}
  //     },
  //     {
  //       path: 'addMenu',
  //       name: 'addMenu',
  //       component: () => import('@/views/ums/menu/add'),
  //       meta: {title: '添加菜单'},
  //       hidden: true
  //     },
  //     {
  //       path: 'updateMenu',
  //       name: 'updateMenu',
  //       component: () => import('@/views/ums/menu/update'),
  //       meta: {title: '修改菜单'},
  //       hidden: true
  //     },
  //     {
  //       path: 'resource',
  //       name: 'resource',
  //       component: () => import('@/views/ums/resource/index'),
  //       meta: {title: '资源列表', icon: 'ums-resource'}
  //     },
  //     {
  //       path: 'resourceCategory',
  //       name: 'resourceCategory',
  //       component: () => import('@/views/ums/resource/categoryList'),
  //       meta: {title: '资源分类'},
  //       hidden: true
  //     },{
  //       path: 'model',
  //       name: 'model',
  //       component: () => import('@/views/news/model/index'),
  //       meta: {title: '新闻分类', icon: 'news-model'}
  //     },
  //     {
  //       path: 'addModel',
  //       name: 'addModel',
  //       component: () => import('@/views/news/model/add'),
  //       meta: {title: '添加分类'},
  //       hidden: true
  //     },
  //     {
  //       path: 'updateModel',
  //       name: 'updateModel',
  //       component: () => import('@/views/news/model/update'),
  //       meta: {title: '修改分类'},
  //       hidden: true
  //     },
  //     {
  //       path: 'log',
  //       name: 'log',
  //       component: () => import('@/views/log/index'),
  //       meta: {title: '操作日志', icon: 'ums-resource'}
  //     }
  //   ]
  // },


  // 111111111




  {
    path: '/bhgkNews',
    component: Layout,
    name: 'bhgkNews',
    meta: { title: '本会概况', icon: 'test' },
    children: [
      {
        path: 'bhjjNews',
        component: () => import('@/views/news/admin/bhjjNews'),
        meta: { title: '本会简介', icon: '' }
      },
      {
        path: 'bhzcNews',
        component: () => import('@/views/news/admin/bhzcNews'),
        meta: { title: '本会章程', icon: '' }
      },
      {
        path: 'dwhymlNews',
        component: () => import('@/views/news/admin/dwhymlNews'),
        meta: { title: '会员名录', icon: '' }
      },
      {
        path: 'bhfzrNews',
        component: () => import('@/views/news/admin/bhfzrNews'),
        meta: { title: '本会负责人', icon: '' }
      },
      {
        path: 'lsmlNews',
        component: () => import('@/views/news/admin/lsmlNews'),
        meta: { title: '理事名录', icon: '' }
      },
      {
        path: 'nsjgNews',
        component: () => import('@/views/news/admin/nsjgNews'),
        meta: { title: '内设机构', icon: '' }
      },
      {
        path: 'glzdNews',
        component: () => import('@/views/news/admin/glzdNews'),
        meta: { title: '管理制度', icon: '' }
      },
      {
        path: 'addNews',
        name: 'addNews',
        component: () => import('@/views/news/admin/add'),
        meta: { title: '添加新闻' },
        hidden: true
      },
      {
        path: 'updateNews',
        name: 'updateNews',
        component: () => import('@/views/news/admin/update'),
        meta: { title: '修改新闻' },
        hidden: true
      }, {
        path: '/chairmanMailbox',
        component: LayoutMain,
        redirect: '/chairmanMailbox/chairmanMailboxList',
        name: 'chairmanMailbox',
        meta: { title: '会长信箱', icon: '' },
        children: [
          {
            path: 'chairmanMailboxList',
            name: 'chairmanMailboxList',
            component: () => import('@/views/chairmanMailbox/index'),
            meta: { title: '会长信箱', icon: '' }
          },
          {
            path: 'addChairmanMailbox',
            name: 'addChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/add'),
            meta: { title: '添加会长信箱', icon: 'news-model' },
            hidden: true
          },
          {
            path: 'updateChairmanMailbox',
            name: 'updateChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/update'),
            meta: { title: '修改会长信箱', icon: 'news-model' },
            hidden: true
          },
          {
            path: 'showChairmanMailbox',
            name: 'showChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/show'),
            meta: { title: '查看会长信箱', icon: 'news-model' },
            hidden: true
          },
          {
            path: 'replyChairmanMailbox',
            name: 'replyChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/reply'),
            meta: { title: '回复' },
            hidden: true
          }
        ]
      },
      {
        path: 'bzsmNews',
        component: () => import('@/views/news/admin/bzsmNews'),
        meta: { title: '本站声明', icon: '' }
      }

    ]
  },
  {
    path: '/homeNews',
    component: Layout,
    /*redirect: '/news/admin',*/
    name: 'homeNews',
    meta: { title: '工作资讯', icon: 'news' },
    children: [
      {
        path: 'toutiao',
        component: () => import('@/views/news/admin/toutiaoNews'),
        meta: { title: '重要资讯', icon: '' }
      },
      {
        path: 'lunbotu',
        component: () => import('@/views/news/admin/lunbotuNews'),
        meta: { title: '最新资讯', icon: '' }
      },
      {
        path: 'tzgg',
        component: () => import('@/views/news/admin/tzggNews'),
        meta: { title: '通知公告', icon: '' }
      },
      {
        path: 'gzdt',
        component: () => import('@/views/news/admin/gzdtNews'),
        meta: { title: '工作动态', icon: '' }
      },
      {
        path: 'addNews',
        name: 'addNews',
        component: () => import('@/views/news/admin/add'),
        meta: { title: '添加新闻' },
        hidden: true
      },
      {
        path: 'updateNews',
        name: 'updateNews',
        component: () => import('@/views/news/admin/update'),
        meta: { title: '修改新闻' },
        hidden: true
      }
    ]
  },
  {
    path: '/zhengcefaguiNews',
    component: Layout,
    redirect: '/zhengcefaguiNews/binzangfagui',
    name: 'zhengcefaguiNews',
    meta: { title: '政策法规', icon: 'fagui' },
    children: [
      {
        path: 'binzangfagui',
        component: () => import('@/views/news/admin/binzangfaguiNews'),
        meta: { title: '殡葬法规', icon: '' }

      },
      {
        path: '/biaozhunguifan',
        component: LayoutMain,
        redirect: '/biaozhunguifan/binzangfwbz',
        name: 'biaozhunguifan',
        meta: { title: '标准规范', icon: '' },
        children: [

          {
            path: 'binzangssbz',
            component: () => import('@/views/news/admin/binzangsheshibzNews'),
            name: 'binzangssbz',
            meta: { title: '殡葬设施标准', icon: '' }
          },
          {
            path: 'binzangsbbz',
            component: () => import('@/views/news/admin/binzangshebeibzNews'),
            name: 'binzangsbbz',
            meta: { title: '殡葬设备标准', icon: '' }
          },
          {
            path: 'binzangfwbz',
            component: () => import('@/views/news/admin/binzangfuwubzNews'),
            name: 'binzangfwbz',
            meta: { title: '殡葬服务标准', icon: '' }
          },
          {
            path: 'binzangqtbz',
            component: () => import('@/views/news/admin/binzangqtbzNews'),
            name: 'binzangqtbz',
            meta: { title: '其它殡葬标准', icon: '' }
          },
        ]
      },
      {
        path: '/zhengcewenjian',
        component: LayoutMain,
        name: 'zhengcewenjian',
        meta: { title: '政策文件', icon: '' },
        children: [
          {
            path: 'binzangzhzdwj',
            component: () => import('@/views/news/admin/binzangzhzdwjNews'),
            name: 'binzangzhzdwj',
            meta: { title: '综合指导文件', icon: '' }
          },
          {
            path: 'binzangbzglwj',
            component: () => import('@/views/news/admin/binzangbzglwjNews'),
            name: 'binzangbzglwj',
            meta: { title: '殡葬管理文件', icon: '' }
          },
          {
            path: 'binzangazsswj',
            component: () => import('@/views/news/admin/binzangazsswjNews'),
            name: 'binzangazsswj',
            meta: { title: '安葬设施文件', icon: '' }
          },
          {
            path: 'binzangqtygwj',
            component: () => import('@/views/news/admin/binzangqtygwjNews'),
            name: 'binzangqtygwj',
            meta: { title: '其它有关文件', icon: '' }
          }
        ]
      },
      {
        path: '/chairmanMailbox',
        component: LayoutMain,
        redirect: '/chairmanMailbox2List',
        name: 'chairmanMailbox',
        meta: { title: '', icon: 'chairmanMailbox' },
        children: [
          {
            path: 'chairmanMailbox2List',
            name: 'chairmanMailbox2List',
            component: () => import('@/views/chairmanMailbox/index2'),
            meta: { title: '政策咨询', icon: '' }
          },
          {
            path: 'addChairmanMailbox',
            name: 'addChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/add'),
            meta: { title: '添加政策咨询' },
            hidden: true
          },
          {
            path: 'updateChairmanMailbox',
            name: 'updateChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/update'),
            meta: { title: '修改政策咨询' },
            hidden: true
          },
          {
            path: 'showChairmanMailbox',
            name: 'showChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/show'),
            meta: { title: '查看政策咨询' },
            hidden: true
          },
          {
            path: 'replyChairmanMailbox',
            name: 'replyChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/reply'),
            meta: { title: '回复' },
            hidden: true
          }
        ]
      },

      {
        path: 'addNews',
        name: 'addNews',
        component: () => import('@/views/news/admin/add'),
        meta: { title: '添加新闻' },
        hidden: true
      },
      {
        path: 'updateNews',
        name: 'updateNews',
        component: () => import('@/views/news/admin/update'),
        meta: { title: '修改新闻' },
        hidden: true
      }
    ]
  },
  {
    path: '/bzywNews',
    component: Layout,
    name: 'bzywNews',
    meta: { title: '殡葬业务', icon: 'yewu' },
    children: [
      {
        path: 'ywjlNews',
        component: () => import('@/views/news/admin/ywjlNews'),
        meta: { title: '业务交流', icon: '' }
      },
      {
        path: 'llttNews',
        component: () => import('@/views/news/admin/llttNews'),
        meta: { title: '理论探讨', icon: '' }
      },
      {
        path: 'shgyNews',
        component: () => import('@/views/news/admin/shgyNews'),
        meta: { title: '社会公益', icon: '' }
      },
      {
        path: 'zgtdNews',
        component: () => import('@/views/news/admin/zgtdNews'),
        meta: { title: '职工天地', icon: '' }
      },
      {
        path: 'addNews',
        name: 'addNews',
        component: () => import('@/views/news/admin/add'),
        meta: { title: '添加新闻' },
        hidden: true
      },
      {
        path: 'updateNews',
        name: 'updateNews',
        component: () => import('@/views/news/admin/update'),
        meta: { title: '修改新闻' },
        hidden: true
      },
      {
        path: '/chairmanMailbox',
        component: LayoutMain,
        redirect: '/chairmanMailbox3List',
        name: 'chairmanMailbox',
        meta: { title: '', icon: 'chairmanMailbox' },
        children: [
          {
            path: 'chairmanMailbox3List',
            name: 'chairmanMailbox3List',
            component: () => import('@/views/chairmanMailbox/index3'),
            meta: { title: '业务咨询', icon: '' }
          },
          {
            path: 'addChairmanMailbox',
            name: 'addChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/add'),
            meta: { title: '添加业务咨询' },
            hidden: true
          },
          {
            path: 'updateChairmanMailbox',
            name: 'updateChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/update'),
            meta: { title: '修改业务咨询' },
            hidden: true
          },
          {
            path: 'showChairmanMailbox',
            name: 'showChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/show'),
            meta: { title: '查看业务咨询' },
            hidden: true
          },
          {
            path: 'replyChairmanMailbox',
            name: 'replyChairmanMailbox',
            component: () => import('@/views/chairmanMailbox/reply'),
            meta: { title: '回复' },
            hidden: true
          }
        ]
      }
    ]
  },
  {
    path: '/bianmin',
    name: 'bianmin',
    component: Layout,
    redirect: '/cloud/cloudMemorialHall',
    meta: { title: '便民服务', icon: 'class1' },
    children: [
      {
        path: '/cloud',
        component: LayoutMain,
        redirect: '/cloudMemorialHall',
        meta: { title: '网上纪念馆', icon: '' },
        children: [
          {
            path: 'cloudMemorialHall',
            name: 'cloudMemorialHall',
            component: () => import('@/views/cloud/cloudMemorialHall/index'),
            meta: { title: '纪念馆审核', icon: '' }
          },
          {
            path: 'updateCloudMemorialHall',
            name: 'updateCloudMemorialHall',
            component: () => import('@/views/cloud/cloudMemorialHall/update'),
            meta: { title: '查看纪念馆详情' },
            hidden: true
          },
          {
            path: 'cloudArticleList',
            name: 'cloudArticleList',
            component: () => import('@/views/cloud/cloudArticle/index'),
            meta: { title: '查看纪念文集' },
            hidden: true
          },
          {
            path: 'showCloudArticleDetail',
            name: 'showCloudArticleDetail',
            component: () => import('@/views/cloud/cloudArticle/show'),
            meta: { title: '查看纪念文章详情' },
            hidden: true
          }, {
            path: 'cloudPhotoAlbumList',
            name: 'cloudPhotoAlbumList',
            component: () => import('@/views/cloud/cloudAlbum/index'),
            meta: { title: '查看纪念相册' },
            hidden: true
          }, {
            path: 'cloudPhotoAlbumImagesList',
            name: 'cloudPhotoAlbumImagesList',
            component: () => import('@/views/cloud/cloudAlbumImages/index'),
            meta: { title: '查看纪念相册图片' },
            hidden: true
          }, {
            path: 'cloudPhotoAlbumImagesList',
            name: 'cloudPhotoAlbumImagesList',
            component: () => import('@/views/cloud/cloudAlbumImages/index'),
            meta: { title: '查看纪念相册图片' },
            hidden: true
          }, {
            path: 'cloudMemorialHallVideoList',
            name: 'cloudMemorialHallVideoList',
            component: () => import('@/views/cloud/cloudMemorialHallVideo/index'),
            meta: { title: '查看纪念视频' },
            hidden: true
          }, {
            path: 'cloudMemorialHallVideoList',
            name: 'cloudMemorialHallVideoList',
            component: () => import('@/views/cloud/cloudMemorialHallVideo/index'),
            meta: { title: '查看纪念视频' },
            hidden: true
          }, {
            path: 'cloudLeaveMessageList',
            name: 'cloudLeaveMessageList',
            component: () => import('@/views/cloud/cloudLeaveMessage/index'),
            meta: { title: '查看祭祀留言' },
            hidden: true
          },
          {
            path: 'showCloudLeaveMessageDetail',
            name: 'showCloudLeaveMessageDetail',
            component: () => import('@/views/cloud/cloudLeaveMessage/show'),
            meta: { title: '查看祭祀留言详情' },
            hidden: true
          },
          {
            path: '/cloudProductCate',
            component: LayoutMain,
            redirect: '/cloudProductCate/cloudProductCateList',
            name: 'cloudProductCate',
            meta: { title: '祭品', icon: 'product' },
            children: [{
              path: 'cloudProductCateList',
              name: 'cloudProductCateList',
              component: () => import('@/views/cloud/cloudProductCate/index'),
              meta: { title: '祭品分类', icon: '' }
            },
            {
              path: 'addProductCate',
              name: 'addProductCate',
              component: () => import('@/views/cloud/cloudProductCate/add'),
              meta: { title: '添加祭品分类' },
              hidden: true
            },
            {
              path: 'updateProductCate',
              name: 'updateProductCate',
              component: () => import('@/views/cloud/cloudProductCate/update'),
              meta: { title: '修改祭品分类' },
              hidden: true
            }]
          },
          {
            path: '/cloudMemorialHallTaocan',
            component: LayoutMain,
            redirect: '/cloudMemorialHallTaocan/cloudMemorialHallTaocan',
            name: 'cloudMemorialHallTaocan',
            meta: { title: '纪念馆场景管理', icon: 'product' },
            children: [
              {
                path: 'cloudMemorialHallTaocan',
                name: 'cloudMemorialHallTaocan',
                component: () => import('@/views/cloud/cloudMemorialHallTaocan/index'),
                meta: { title: '纪念馆场景管理', icon: '' }
              }, {
                path: 'addTaocan',
                name: 'addTaocan',
                component: () => import('@/views/cloud/cloudMemorialHallTaocan/add'),
                meta: { title: '添加纪念馆场景', icon: 'product-list' },
                hidden: true
              }, {
                path: 'updateTaocan',
                name: 'updateTaocan',
                component: () => import('@/views/cloud/cloudMemorialHallTaocan/update'),
                meta: { title: '修改纪念馆场景', icon: 'product-list' },
                hidden: true
              }]
          }
        ]
      },
      {
        path: '/dksmNew',
        component: LayoutMain,
        redirect: '/dksmNew/order',
        name: 'dksmNew',
        meta: { title: '代客扫墓', icon: '' },
        children: [
          {
            path: 'project',
            name: 'project',
            component: () => import('@/views/projectManagement'),
            meta: { title: '服务项目管理', icon: '' }
          },
          {
            path: 'list',
            name: 'list',
            component: () => import('@/views/orderList'),
            meta: { title: '订单列表', icon: '' }
          },

        ]
      },
      /*{
        path:'/ecologicalBurial',
        component: LayoutMain,
        redirect: '/ecologicalBurial/ecologicalBurialList',
        name: 'ecologicalBurial',
        meta: {title: '', icon: 'ecologicalBurial'},
        children: [
          {
            path: 'ecologicalBurialList',
            name: 'ecologicalBurialList',
            component: () => import('@/views/ecologicalBurial/index'),
            meta: {title: '节地生态葬', icon: 'order'}
          },
          {
            path: 'addEcologicalBurial',
            name: 'addEcologicalBurial',
            component: () => import('@/views/ecologicalBurial/add'),
            meta: {title: '添加节地生态葬'},
            hidden: true
          },
          {
            path: 'updateEcologicalBurial',
            name: 'updateEcologicalBurial',
            component: () => import('@/views/ecologicalBurial/update'),
            meta: {title: '修改节地生态葬'},
            hidden: true
          },
          {
            path: 'showEcologicalBurial',
            name: 'showEcologicalBurial',
            component: () => import('@/views/ecologicalBurial/show'),
            meta: {title: '查看节地生态葬'},
            hidden: true
          },
          {
            path: 'replyEcologicalBurial',
            name: 'replyEcologicalBurial',
            component: () => import('@/views/ecologicalBurial/reply'),
            meta: {title: '回复'},
            hidden: true
          }
        ]
      },*/
      {
        path: '/makeappointment',
        component: LayoutMain,
        redirect: '/makeappointment/seting',
        name: 'makeappointment',
        meta: { title: '祭扫预约', icon: '' },
        children: [
          {
            path: 'makeappointmentServiceinfo',
            name: 'makeappointmentServiceinfo',
            component: () => import('@/views/makeappointment/serviceinfo/index'),
            meta: { title: '温馨提示', icon: '' },
          },
          {
            path: 'addMakeappointmentServiceinfo',
            name: 'addMakeappointmentServiceinfo',
            component: () => import('@/views/makeappointment/serviceinfo/add'),
            meta: { title: '添加温馨提示' },
            hidden: true
          },
          {
            path: 'updateMakeappointmentServiceinfo',
            name: 'updateMakeappointmentServiceinfo',
            component: () => import('@/views/makeappointment/serviceinfo/update'),
            meta: { title: '修改温馨提示' },
            hidden: true
          },
          {
            path: 'makeappointmentLook',
            name: 'makeappointmentLook',
            component: () => import('@/views/makeappointment/look/index'),
            meta: { title: '预约看板' },
          }, {
            path: 'makeappointment/date',
            name: 'makeappointment/date',
            component: () => import('@/views/makeappointment/date/index'),
            meta: { title: '预约日期', icon: '' },
          },
          {
            path: 'seting',
            name: 'seting',
            component: () => import('@/views/makeappointment/seting/index'),
            meta: { title: '预约规则', icon: '' }
          }, {
            path: 'makeappointmentList',
            name: 'makeappointmentList',
            component: () => import('@/views/makeappointment/yy/index'),
            meta: { title: '预约审核', icon: '' },
          },
          {
            path: '/makeappointment/seting/update',
            name: 'makeappointment/seting/update',
            component: () => import('@/views/makeappointment/seting/update'),
            meta: { title: '修改设置' },
            hidden: true
          },
          {
            path: '/makeappointment/seting/updateTime',
            name: 'makeappointment/seting/updateTime',
            component: () => import('@/views/makeappointment/seting/updateTime'),
            meta: { title: '修改设置' },
            hidden: true
          },
          {
            path: '/makeappointment/date/updateTime',
            name: 'makeappointment/date/updateTime',
            component: () => import('@/views/makeappointment/date/updateTime'),
            meta: { title: '修改设置' },
            hidden: true
          },
          {
            path: '/makeappointment/date/setDate',
            name: 'makeappointment/date/setDate',
            component: () => import('@/views/makeappointment/date/setDate'),
            meta: { title: '设置日期' },
            hidden: true
          },
          {
            path: '/makeappointment/date/time_index',
            name: 'makeappointment/date/time_index',
            component: () => import('@/views/makeappointment/date/time_index'),
            meta: { title: '设置时间' },
            hidden: true
          },
        ]
      },
      /*{
        path:'/zxju',
        component: LayoutMain,
        name: 'zxju',
        redirect: '/cloudElegance/cloudEleganceList',
        meta: {title: '在线寄语', icon: 'product-list'},
        children: [
          {
            path:'/cloudElegance',
            component: LayoutMain,
            redirect: '/cloudElegance/cloudEleganceList',
            name: 'cloudElegance',
            meta: {title: '在线挽联', icon: 'order'},
            children: [
              {
                path: 'cloudEleganceList',
                name: 'cloudEleganceList',
                component: () => import('@/views/cloudElegance/index'),
                meta: {title: '在线挽联列表', icon: 'order'}
              },
              {
                path: 'addCloudElegance',
                name: 'addCloudElegance',
                component: () => import('@/views/cloudElegance/add'),
                meta: {title: '添加在线挽联'},
                hidden: true
              },
              {
                path: 'updateCloudElegance',
                name: 'updateCloudElegance',
                component: () => import('@/views/cloudElegance/update'),
                meta: {title: '修改在线挽联'},
                hidden: true
              }
            ]
          },{
            path:'/cloudEulogy',
            component: LayoutMain,
            redirect: '/cloudEulogy/cloudEulogyList',
            name: 'cloudEulogy',
            meta: {title: '在线悼词', icon: 'order'},
            children: [
              {
                path: 'cloudEulogyList',
                name: 'cloudEulogyList',
                component: () => import('@/views/cloudEulogy/index'),
                meta: {title: '在线悼词列表', icon: 'order'}
              },
              {
                path: 'addCloudEulogy',
                name: 'addCloudEulogy',
                component: () => import('@/views/cloudEulogy/add'),
                meta: {title: '添加在线悼词'},
                hidden: true
              },
              {
                path: 'updateCloudEulogy',
                name: 'updateCloudEulogy',
                component: () => import('@/views/cloudEulogy/update'),
                meta: {title: '修改在线悼词'},
                hidden: true
              }
            ]
          },{
            path:'/cloudObituary',
            component: LayoutMain,
            redirect: '/cloudObituary/cloudObituaryList',
            name: 'cloudObituary',
            meta: {title: '在线讣告', icon: 'order'},
            children: [
              {
                path: 'cloudObituaryList',
                name: 'cloudObituaryList',
                component: () => import('@/views/cloudObituary/index'),
                meta: {title: '在线讣告列表', icon: 'order'}
              },
              {
                path: 'addCloudObituary',
                name: 'addCloudObituary',
                component: () => import('@/views/cloudObituary/add'),
                meta: {title: '添加在线讣告'},
                hidden: true
              },
              {
                path: 'updateCloudObituary',
                name: 'updateCloudObituary',
                component: () => import('@/views/cloudObituary/update'),
                meta: {title: '修改在线讣告'},
                hidden: true
              }
            ]
          },
        ],
      },*/
      {
        path: '/jdstazNews',
        component: LayoutMain,
        redirect: '/jdstazNews/jdstazNewsList',
        name: 'serviceRating',
        meta: { title: '', icon: 'serviceRating' },
        children: [
          {
            path: 'jdstazNewsList',
            name: 'jdstazNewsList',
            component: () => import('@/views/news/admin/jdstazNews'),
            meta: { title: '节地生态安葬', icon: '' }
          },
          {
            path: 'addNews',
            name: 'addNews',
            component: () => import('@/views/news/admin/add'),
            meta: { title: '添加新闻' },
            hidden: true
          },
          {
            path: 'updateNews',
            name: 'updateNews',
            component: () => import('@/views/news/admin/update'),
            meta: { title: '修改新闻' },
            hidden: true
          }
        ]
      },
      {
        path: '/serviceRating',
        component: LayoutMain,
        redirect: '/serviceRating/serviceRatingList',
        name: 'serviceRating',
        meta: { title: '', icon: 'serviceRating' },
        children: [
          {
            path: 'serviceRatingList',
            name: 'serviceRatingList',
            component: () => import('@/views/serviceRating/index'),
            meta: { title: '服务评价', icon: '' }
          },
          {
            path: 'addServiceRating',
            name: 'addServiceRating',
            component: () => import('@/views/serviceRating/add'),
            meta: { title: '添加服务评价' },
            hidden: true
          },
          {
            path: 'updateServiceRating',
            name: 'updateServiceRating',
            component: () => import('@/views/serviceRating/update'),
            meta: { title: '修改服务评价' },
            hidden: true
          },
          {
            path: 'showServiceRating',
            name: 'showServiceRating',
            component: () => import('@/views/serviceRating/show'),
            meta: { title: '查看服务评价' },
            hidden: true
          }
        ]
      },
      {
        path: '/bzdwNew',
        component: LayoutMain,
        redirect: '/bzdwNew/funeralUnit',
        name: 'bzdwNew',
        meta: { title: '殡葬单位查询', icon: '' },
        children: [
          {
            path: 'funeralUnit',
            name: 'funeralUnit',
            component: () => import('@/views/funeralUnit/funeralHome'),
            meta: { title: '殡仪馆查询', icon: '' }
          },
         {
           path: 'cemetery',
           name: 'cemetery',
           component: () => import('@/views/funeralUnit/cemetery'),
           meta: { title: '墓园查询', icon: '' }
         },
         {
           path: 'agency',
           name: 'agency',
           component: () => import('@/views/funeralUnit/agency'),
           meta: { title: '殡葬代理服务查询', icon: '' }
         },
         {
           path: 'device',
           name: 'device',
           component: () => import('@/views/funeralUnit/device'),
           meta: { title: '殡葬设备查询', icon: '' }
         },
         {
           path: 'articles',
           name: 'articles',
           component: () => import('@/views/funeralUnit/articles'),
           meta: { title: '殡葬用品查询', icon: '' }
         },

        ]
      },
    ]
  },
  {
    path: '/xwzxNews',
    component: Layout,
    name: 'xwzxNews',
    meta: { title: '殡葬博览', icon: 'class' },
    children: [
      // {
      //   path: 'xwzbNews',
      //   component: () => import('@/views/news/admin/xwzbNews'),
      //   meta: {title: '新闻摘报', icon: ''}
      // },
      {
        path: 'bzlsNews',
        component: () => import('@/views/news/admin/bzlsNews'),
        meta: { title: '殡葬历史', icon: '' }
      },
      {
        path: '/bzwhNews',
        component: LayoutMain,
        redirect: '/bzywNews/zgbzwh',
        name: 'bzwhNews',
        meta: { title: '殡葬文化' },
        children: [
          {
            path: 'zgbzwh',
            component: () => import('@/views/news/admin/zgbzwhNews'),
            name: 'zgbzwh',
            meta: { title: '中国殡葬文化', icon: '' }
          },
          {
            path: 'wgbzwh',
            component: () => import('@/views/news/admin/wgbzwhNews'),
            name: 'wgbzwh',
            meta: { title: '外国殡葬文化', icon: '' }
          },
          {
            path: 'addNews',
            name: 'addNews',
            component: () => import('@/views/news/admin/add'),
            meta: { title: '添加新闻' },
            hidden: true
          },
          {
            path: 'updateNews',
            name: 'updateNews',
            component: () => import('@/views/news/admin/update'),
            meta: { title: '修改新闻' },
            hidden: true
          }
        ]
      },
      {
        path: 'bzcsNews',
        component: () => import('@/views/news/admin/bzcsNews'),
        meta: { title: '殡葬常识', icon: '' }
      },
      {
        path: 'bzysNews',
        component: () => import('@/views/news/admin/bzysNews'),
        meta: { title: '殡葬轶事', icon: '' }
      },
      {
        path: 'dwscNews',
        component: () => import('@/views/news/admin/dwscNews'),
        meta: { title: '悼亡诗词', icon: '' }
      },
      // {
      //   path:'/bzwaNews',
      //   component: LayoutMain,
      //   redirect: '/bzwaNews/wlhc',
      //   name: 'bzwaNews',
      //   meta: {title: '殡葬文案'},
      //   children: [
      //     {
      //       path: 'wlhc',
      //       component: () => import('@/views/news/admin/wlhcNews'),
      //       name: 'wlhc',
      //       meta: {title: '挽联荟萃', icon: ''}
      //     },
      //     {
      //       path: 'muzhiming',
      //       component: () => import('@/views/news/admin/muzhimingNews'),
      //       name: 'muzhiming',
      //       meta: {title: '墓志铭', icon: ''}
      //     },{
      //       path: 'bwjj',
      //       component: () => import('@/views/news/admin/bwjjNews'),
      //       name: 'bwjj',
      //       meta: {title: '碑文集锦', icon: ''}
      //     },{
      //       path: 'wmdx',
      //       component: () => import('@/views/news/admin/wmdxNews'),
      //       name: 'wmdx',
      //       meta: {title: '致哀短信', icon: ''}
      //     },
      //     {
      //       path: 'daoci',
      //       component: () => import('@/views/news/admin/daociNews'),
      //       name: 'daoci',
      //       meta: {title: '悼词', icon: ''}
      //     },
      //     {
      //       path: 'picture',
      //       component: () => import('@/views/news/admin/bzpicture'),
      //       name: 'picture',
      //       meta: {title: '殡葬图片', icon: ''}
      //     },
      //     {
      //       path: 'addNews',
      //       name: 'addNews',
      //       component: () => import('@/views/news/admin/add'),
      //       meta: {title: '添加新闻'},
      //       hidden: true
      //     },
      //     {
      //       path: 'updateNews',
      //       name: 'updateNews',
      //       component: () => import('@/views/news/admin/update'),
      //       meta: {title: '修改新闻'},
      //       hidden: true
      //     }
      //   ]
      // },
      /*{
        path: 'mtgdNews',
        component: () => import('@/views/news/admin/mtgdNews'),
        meta: {title: '媒体观点', icon: 'order'}
      },
      {
        path: 'bzblNews',
        component: () => import('@/views/news/admin/bzblNews'),
        meta: {title: '殡葬博览', icon: 'order'}
      },*/
      {
        path: 'addNews',
        name: 'addNews',
        component: () => import('@/views/news/admin/add'),
        meta: { title: '添加新闻' },
        hidden: true
      },
      {
        path: 'updateNews',
        name: 'updateNews',
        component: () => import('@/views/news/admin/update'),
        meta: { title: '修改新闻' },
        hidden: true
      }
    ]
  },

  {
    path: '/member',
    component: Layout,
    redirect: '/member/admin',
    name: 'member',
    meta: { title: '会员简介', icon: 'vip' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/member/admin/index'),
        meta: { title: '会员列表', icon: '' }
      },
      {
        path: '/album',
        component: LayoutMain,
        redirect: '/album/album',
        name: 'album',
        meta: { title: '环境相册', icon: '' },
        children: [
          {
            path: 'album',
            name: 'album',
            component: () => import('@/views/pic/album/index'),
            meta: { title: '会员环境相册', icon: '' }
          },
          {
            path: 'albumDetail',
            name: 'albumDetail',
            component: () => import('@/views/pic/album/components/AlbumDetail'),
            meta: { title: '相册详情' },
            hidden: true
          },
          {
            path: 'albumPic',
            name: 'albumPic',
            component: () => import('@/views/pic/albumPic/index'),
            meta: { title: '会员环境图片', icon: '' }
          },
          {
            path: 'AlbumPicDetail',
            name: 'AlbumPicDetail',
            component: () => import('@/views/pic/albumPic/components/AlbumPicDetail'),
            meta: { title: '相册图片详情' },
            hidden: true
          }
        ]
      }, {
        path: 'cemetery',
        name: 'cemetery',
        component: () => import('@/views/cemetery/cemetery'),
        meta: { title: '会员拓展', icon: '' }
      },
      {
        path: '/djpdNews',
        component: LayoutMain,
        redirect: '/djpdNews/byg',
        name: 'djpdNews',
        meta: { title: '等级评定' },
        children: [
          {
            path: 'byg',
            component: () => import('@/views/news/admin/bygNews'),
            name: 'byg',
            meta: { title: '殡仪馆', icon: '' }
          },
          {
            path: 'gongmu',
            component: () => import('@/views/news/admin/gongmuNews'),
            name: 'gongmu',
            meta: { title: '公墓', icon: '' }
          },
          {
            path: 'guhuitang',
            component: () => import('@/views/news/admin/guhuitangNews'),
            name: 'guhuitang',
            meta: { title: '骨灰堂', icon: '' }
          },
          {
            path: 'bzdlfwdw',
            component: () => import('@/views/news/admin/bzdlfwdwNews'),
            name: 'bzdlfwdw',
            meta: { title: '殡葬代理服务单位', icon: '' }
          },
          {
            path: 'addNews',
            name: 'addNews',
            component: () => import('@/views/news/admin/add'),
            meta: { title: '添加新闻' },
            hidden: true
          },
          {
            path: 'updateNews',
            name: 'updateNews',
            component: () => import('@/views/news/admin/update'),
            meta: { title: '修改新闻' },
            hidden: true
          }
        ]
      },
      {
        path: '/zzmlNews',
        component: LayoutMain,
        redirect: '/zzmlNews/byg',
        name: 'zzmlNews',
        meta: { title: '资质名录' },
        children: [
          {
            path: 'ythhs',
            component: () => import('@/views/news/admin/ythhsNews'),
            name: 'ythhs',
            meta: { title: '遗体火化师', icon: '' }
          },
          {
            path: 'ytffzrs',
            component: () => import('@/views/news/admin/ytffzrsNews'),
            name: 'ytffzrs',
            meta: { title: '遗体防腐整容师', icon: '' }
          },
          {
            path: 'byffy',
            component: () => import('@/views/news/admin/byffyNews'),
            name: 'byffy',
            meta: { title: '殡仪服务员', icon: '' }
          },
          {
            path: 'gmgly',
            component: () => import('@/views/news/admin/gmglyNews'),
            name: 'gmgly',
            meta: { title: '公墓管理员', icon: '' }
          },
          {
            path: 'bzdlfwcyry',
            component: () => import('@/views/news/admin/bzdlfwcyryNews'),
            name: 'bzdlfwcyry',
            meta: { title: '殡葬代理服务从业人员', icon: '' }
          },
          {
            path: 'addNews',
            name: 'addNews',
            component: () => import('@/views/news/admin/add'),
            meta: { title: '添加新闻' },
            hidden: true
          },
          {
            path: 'updateNews',
            name: 'updateNews',
            component: () => import('@/views/news/admin/update'),
            meta: { title: '修改新闻' },
            hidden: true
          }
        ]
      },
      {
        path: 'addNews',
        name: 'addNews',
        component: () => import('@/views/news/admin/add'),
        meta: { title: '添加新闻' },
        hidden: true
      },
      {
        path: 'updateNews',
        name: 'updateNews',
        component: () => import('@/views/news/admin/update'),
        meta: { title: '修改新闻' },
        hidden: true
      }, {
        path: 'addAdmin',
        name: 'addAdmin',
        component: () => import('@/views/member/admin/add'),
        meta: { title: '添加会员' },
        hidden: true
      }, {
        path: 'updateAdmin',
        name: 'updateAdmin',
        component: () => import('@/views/member/admin/update'),
        meta: { title: '修改会员' },
        hidden: true
      }, {
        path: 'addCemetery',
        name: 'addCemetery',
        component: () => import('@/views/cemetery/CemeteryForm'),
        meta: { title: '添加会员拓展' },
        hidden: true
      }]
  },

  {
    path: '/umss',
    component: Layout,
    name: 'umss',
    meta: { title: '系统设置', icon: 'set' },

    children: [

      {
        path: '/ums',
        redirect: '/ums/admin',
        name: 'ums',
        component: LayoutMain,
        meta: { title: '权限管理', icon: '' },
        children: [
          {
            path: 'admin',
            name: 'admin',
            component: () => import('@/views/ums/admin/index'),
            meta: { title: '用户列表', icon: '' }
          },
          {
            path: 'addAdmin',
            name: 'addAdmin',
            component: () => import('@/views/member/admin/add'),
            meta: { title: '添加会员' },
            hidden: true
          }, {
            path: 'updateAdmin',
            name: 'updateAdmin',
            component: () => import('@/views/member/admin/update'),
            meta: { title: '修改会员' },
            hidden: true
          },
          {
            path: 'role',
            name: 'role',
            component: () => import('@/views/ums/role/index'),
            meta: { title: '角色列表', icon: '' }
          },
          {
            path: 'menu',
            name: 'menu',
            component: () => import('@/views/ums/menu/index'),
            meta: { title: '菜单列表', icon: '' }
          },
          {
            path: 'resource',
            name: 'resource',
            component: () => import('@/views/ums/resource/index'),
            meta: { title: '资源列表', icon: '' }
          },
          {
            path: 'allocMenu',
            name: 'allocMenu',
            component: () => import('@/views/ums/role/allocMenu'),
            meta: { title: '分配菜单' },
            hidden: true
          },
          {
            path: 'allocResource',
            name: 'allocResource',
            component: () => import('@/views/ums/role/allocResource'),
            meta: { title: '分配资源' },
            hidden: true
          },
          {
            path: 'addMenu',
            name: 'addMenu',
            component: () => import('@/views/ums/menu/add'),
            meta: { title: '添加菜单' },
            hidden: true
          },
          {
            path: 'updateMenu',
            name: 'updateMenu',
            component: () => import('@/views/ums/menu/update'),
            meta: { title: '修改菜单' },
            hidden: true
          },
          {
            path: 'resourceCategory',
            name: 'resourceCategory',
            component: () => import('@/views/ums/resource/categoryList'),
            meta: { title: '资源分类' },
            hidden: true
          }
        ]
      },
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/log/index'),
        meta: { title: '日志管理', icon: '' }
      },
      {
        path: 'model',
        name: 'model',
        component: () => import('@/views/news/model/index'),
        meta: { title: '新闻分类', icon: '' }
      },
      {
        path: 'addModel',
        name: 'addModel',
        component: () => import('@/views/news/model/add'),
        meta: { title: '添加分类' },
        hidden: true
      },
      {
        path: 'updateModel',
        name: 'updateModel',
        component: () => import('@/views/news/model/update'),
        meta: { title: '修改分类' },
        hidden: true
      }
    ]

  },
  {
    path: '/chairmanMailbox',
    component: Layout,
    redirect: '/chairmanMailbox/chairmanMailboxList',
    name: 'chairmanMailbox',
    meta: { title: '咨询管理', icon: 'product' },
    hidden: true,
    children: [
      {
        path: 'chairmanMailboxList',
        name: 'chairmanMailboxList',
        component: () => import('@/views/chairmanMailbox/index'),
        meta: { title: '会长信箱', icon: 'order' }
      },
      {
        path: 'addChairmanMailbox',
        name: 'addChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/add'),
        meta: { title: '添加会长信箱', icon: 'news-model' },
        hidden: true
      },
      {
        path: 'updateChairmanMailbox',
        name: 'updateChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/update'),
        meta: { title: '修改会长信箱', icon: 'news-model' },
        hidden: true
      },
      {
        path: 'showChairmanMailbox',
        name: 'showChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/show'),
        meta: { title: '查看会长信箱', icon: 'news-model' },
        hidden: true
      },
      {
        path: 'replyChairmanMailbox',
        name: 'replyChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/reply'),
        meta: { title: '回复' },
        hidden: true
      },
      {
        path: 'chairmanMailbox2List',
        name: 'chairmanMailbox2List',
        component: () => import('@/views/chairmanMailbox/index2'),
        meta: { title: '政策咨询', icon: 'order' }
      },
      {
        path: 'addChairmanMailbox',
        name: 'addChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/add'),
        meta: { title: '添加政策咨询' },
        hidden: true
      },
      {
        path: 'updateChairmanMailbox',
        name: 'updateChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/update'),
        meta: { title: '修改政策咨询' },
        hidden: true
      },
      {
        path: 'showChairmanMailbox',
        name: 'showChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/show'),
        meta: { title: '查看政策咨询' },
        hidden: true
      },
      {
        path: 'replyChairmanMailbox',
        name: 'replyChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/reply'),
        meta: { title: '回复' },
        hidden: true
      },
      {
        path: 'chairmanMailbox3List',
        name: 'chairmanMailbox3List',
        component: () => import('@/views/chairmanMailbox/index3'),
        meta: { title: '业务咨询', icon: 'order' }
      },
      {
        path: 'addChairmanMailbox',
        name: 'addChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/add'),
        meta: { title: '添加业务咨询' },
        hidden: true
      },
      {
        path: 'updateChairmanMailbox',
        name: 'updateChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/update'),
        meta: { title: '修改业务咨询' },
        hidden: true
      },
      {
        path: 'showChairmanMailbox',
        name: 'showChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/show'),
        meta: { title: '查看业务咨询' },
        hidden: true
      },
      {
        path: 'replyChairmanMailbox',
        name: 'replyChairmanMailbox',
        component: () => import('@/views/chairmanMailbox/reply'),
        meta: { title: '回复' },
        hidden: true
      }
    ]
  },
  {
    path: '/makeappointment',
    component: Layout,
    redirect: '/makeappointment/seting',
    name: 'makeappointment',
    meta: { title: '扫墓', icon: 'product' },
    hidden: true,
    children: [
      {
        path: 'makeappointmentLook',
        name: 'makeappointmentLook',
        component: () => import('@/views/makeappointment/look/index'),
        meta: { title: '预约看板', icon: 'news-model' },
      }, {
        path: 'makeappointment/date',
        name: 'makeappointment/date',
        component: () => import('@/views/makeappointment/date/index'),
        meta: { title: '预约日期', icon: 'news-model' },
      },
      {
        path: 'seting',
        name: 'seting',
        component: () => import('@/views/makeappointment/seting/index'),
        meta: { title: '预约规则', icon: 'news-model' }
      }, {
        path: 'makeappointmentList',
        name: 'makeappointmentList',
        component: () => import('@/views/makeappointment/yy/index'),
        meta: { title: '预约审核', icon: 'news-model' },
      },
      {
        path: '/makeappointment/seting/update',
        name: 'makeappointment/seting/update',
        component: () => import('@/views/makeappointment/seting/update'),
        meta: { title: '修改设置' },
        hidden: true
      },
      {
        path: '/makeappointment/seting/updateTime',
        name: 'makeappointment/seting/updateTime',
        component: () => import('@/views/makeappointment/seting/updateTime'),
        meta: { title: '修改设置' },
        hidden: true
      },
      {
        path: '/makeappointment/date/updateTime',
        name: 'makeappointment/date/updateTime',
        component: () => import('@/views/makeappointment/date/updateTime'),
        meta: { title: '修改设置' },
        hidden: true
      },
      {
        path: '/makeappointment/date/setDate',
        name: 'makeappointment/date/setDate',
        component: () => import('@/views/makeappointment/date/setDate'),
        meta: { title: '设置日期' },
        hidden: true
      },
      {
        path: '/makeappointment/date/time_index',
        name: 'makeappointment/date/time_index',
        component: () => import('@/views/makeappointment/date/time_index'),
        meta: { title: '设置时间' },
        hidden: true
      },
    ]
  }/*,
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '代客扫墓订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '代客扫墓订单', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '服务信息列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  }*/, {
    path: '/omsNew',
    component: Layout,
    redirect: '/omsNew/order',
    name: 'omsNew',
    meta: { title: '代客扫墓', icon: 'order' },
    hidden: true,
    children: [
      {
        path: 'project',
        name: 'project',
        component: () => import('@/views/projectManagement'),
        meta: { title: '服务项目管理', icon: 'product-list' }
      },
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/orderList'),
        meta: { title: '订单列表', icon: 'product-list' }
      },

    ]
  },
  /*{
    path: '/pmsService',
    component: Layout,
    redirect: '/pms/productService',
    name: 'pmsService',
    meta: {title: '服务管理', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/productService/index'),
      meta: {title: '服务列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/productService/add'),
        meta: {title: '添加服务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/productService/update'),
        meta: {title: '修改服务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productRecycle',
        name: 'productRecycle',
        component: () => import('@/views/pms/productService/index'),
        meta: {title: '商品回收站', icon: 'product-recycle'},
        hidden: true
      },
      {
        path: 'productComment',
        name: 'productComment',
        component: () => import('@/views/pms/productService/index'),
        meta: {title: '商品评价', icon: 'product-comment'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品属性/参数', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },*/
  /*{
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '代客扫墓订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '代客扫墓订单', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '服务信息列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },*/
  /*{
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      }
    ]
  },*/




  /*{
    path: '/shop',
    component: Layout,
    redirect: '/shop/shopLunbo',
    name: 'shop',
    meta: {title: '商家轮播图管理', icon: 'product'},
    children: [
      {
        path:'shopLunbo',
        name:'shopLunbo',
        component:() => import('@/views/shop/shopLunbo/index'),
        meta:{title:'商家轮播图管理'}
      },{
        path: 'addShopLunbo',
        name: 'addShopLunbo',
        component: () => import('@/views/shop/shopLunbo/add'),
        meta: {title: '添加商家轮播图'},
        hidden: true
      },{
        path:'updateShopLunbo',
        name:'updateShopLunbo',
        component: () => import('@/views/shop/shopLunbo/update'),
        meta:{title:'修改商家轮播图'},
        hidden:true
      }]
  },*/










  /*{
    path: '/productComment',
    component: Layout,
    redirect: '/productComment/list',
    name: 'productComment',
    meta: {title: '商品评论管理', icon: 'member'},
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/pms/productComment/index'),
        meta: {title: '商品评论列表', icon: 'product-list'}
      }]
  },*/
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  //如打包文件存放在Tomcat/webapps/aoxinwechat下，
  //那么base就这么写
  //部署到正式服务器上需要放开base
  //base: '/mall-web/',
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js